//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Main',
  data: function data() {
    return {};
  },
  methods: {},
  mounted: function mounted() {},
  computed: {}
};